import { z } from 'zod';
const description = z
    .string()
    .trim()
    .max(2000)
    .nullable()
    .transform((value) => value || null);
const url = z
    .string()
    .trim()
    .max(2048)
    .nullable()
    .transform((value) => value || null)
    .refine((value) => {
    if (value === null)
        return true;
    try {
        const parsed = new URL(value);
        return parsed.protocol === 'https:' && !parsed.username && !parsed.password;
    }
    catch {
        return false;
    }
}, 'Use an HTTPS URL without credentials');
const linkText = z
    .string()
    .trim()
    .max(200)
    .nullable()
    .transform((value) => value || null)
    .optional();
export const CustomerPrivacyTextSchema = z.object({ description, url, linkText }).strict();
export const CustomerPrivacyNoticeSchema = CustomerPrivacyTextSchema.extend({
    translations: z.record(z.string().trim().min(2).max(35), CustomerPrivacyTextSchema).default({}),
})
    .strict()
    .transform((value) => {
    const translations = Object.fromEntries(Object.entries(value.translations).filter(([, text]) => text.description || text.url || text.linkText));
    return !value.description && !value.url && !value.linkText && !Object.keys(translations).length
        ? null
        : { ...value, translations };
})
    .nullable();
export const CustomerPrivacyFieldKeySchema = z.enum([
    'customerPrivacyDescription',
    'customerPrivacyUrl',
    'customerPrivacyLinkText',
]);
export const CustomerPrivacyFieldPatchSchema = z.discriminatedUnion('fieldKey', [
    z
        .object({
        fieldKey: z.literal('customerPrivacyDescription'),
        value: description,
        locale: z.string().min(2).max(35),
        expectedRevision: z.number().int().nonnegative(),
    })
        .strict(),
    z
        .object({
        fieldKey: z.literal('customerPrivacyUrl'),
        value: url,
        locale: z.string().min(2).max(35),
        expectedRevision: z.number().int().nonnegative(),
    })
        .strict(),
    z
        .object({
        fieldKey: z.literal('customerPrivacyLinkText'),
        value: linkText.unwrap(),
        locale: z.string().min(2).max(35),
        expectedRevision: z.number().int().nonnegative(),
    })
        .strict(),
]);
export const CustomerPrivacyFieldsPatchSchema = z
    .array(CustomerPrivacyFieldPatchSchema)
    .max(300)
    .refine((fields) => new Set(fields.map((field) => `${field.locale}:${field.fieldKey}`)).size === fields.length, 'Duplicate privacy field');
export const CustomerPrivacyContentSchema = z.object({
    defaultLocale: z.string(),
    fields: z.array(z.object({
        fieldKey: CustomerPrivacyFieldKeySchema,
        locale: z.string(),
        value: z.string().nullable(),
        revision: z.number().int().nonnegative(),
    })),
});
//# sourceMappingURL=CustomerPrivacyNotice.js.map